module.exports = __webpack_public_path__ + "img/winded.75a03ef1.gif";